var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMirFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4674 8.50318V8.50623C6.46443 8.50623 5.52963 8.50318 5.28036 9.42313C5.05185 10.2667 4.40788 12.5946 4.39007 12.6588H4.21202C4.21202 12.6588 3.55321 10.2789 3.32174 9.42007C3.07246 8.50012 2.1347 8.50318 2.1347 8.50318H0V15.5001H2.13569V11.3445H2.31374L3.56014 15.5001H5.04295L6.28934 11.3476H6.4674V15.5001H8.60308V8.50318H6.4674ZM14.2692 8.50318C14.2692 8.50318 13.6431 8.56125 13.3493 9.23673L11.8368 12.6588H11.6587V8.50318H9.52304V15.5001H11.54C11.54 15.5001 12.1959 15.439 12.4897 14.7666L13.9725 11.3445H14.1506V15.5001H16.2862V8.50318H14.2692ZM17.2358 11.6807V15.5001H19.3715V13.27H21.6853C22.6943 13.27 23.548 12.6068 23.8655 11.6818H17.2358V11.6807Z",
    fill: "#9CA0A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6862 8.5H16.936C17.1734 9.83256 18.1438 10.9013 19.3981 11.2497C19.6893 11.3309 19.9897 11.372 20.2914 11.372H23.9524C23.9851 11.213 23.9999 11.051 23.9999 10.8829C23.9999 9.56666 22.9642 8.5 21.6862 8.5Z",
    fill: "#9CA0A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirFooter);
export default __webpack_public_path__ + "static/media/MIRFooter.b56111d46f28f2f83e417cec7b50a362.svg";
export { ForwardRef as ReactComponent };